import { render, staticRenderFns } from "./OrderItemCardCmp.vue?vue&type=template&id=b5e0ac4a&scoped=true&"
import script from "./OrderItemCardCmp.vue?vue&type=script&lang=js&"
export * from "./OrderItemCardCmp.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemCardCmp.vue?vue&type=style&index=0&id=b5e0ac4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e0ac4a",
  null
  
)

export default component.exports